const CONFIRM_ACCOUNT = 'CONFIRM_ACCOUNT';
const SET_LOGIN_REDIRECT = 'SET_LOGIN_REDIRECT';

const confirmAccount = () => ({
  type: CONFIRM_ACCOUNT
});

const setLoginRedirection = (shouldRedirectToLogin) => ({
  type: SET_LOGIN_REDIRECT,
  payload: {
    shouldRedirectToLogin
  }
});

export {
  SET_LOGIN_REDIRECT,
  CONFIRM_ACCOUNT,
  setLoginRedirection,
  confirmAccount
};
